/**
 * Custom hooks for Epic 5: Nutrition, Habits & Check-ins
 */
import useSWR from "swr";
import { fetcher } from "../lib/api";

const API_URL = process.env.REACT_APP_BACKEND_URL;

// ========== Nutrition ==========
export function useMyNutrition() {
  const { data, error, isLoading, mutate } = useSWR("/api/client/nutrition", fetcher);
  return { logs: data || [], isLoading, isError: error, mutate };
}

export function useTodayNutrition() {
  const { data, error, isLoading, mutate } = useSWR("/api/client/nutrition/today", fetcher);
  return { entry: data, isLoading, isError: error, mutate };
}

export function useClientNutrition(clientId) {
  const { data, error, isLoading, mutate } = useSWR(
    clientId ? `/api/admin/clients/${clientId}/nutrition` : null, fetcher
  );
  return { logs: data || [], isLoading, isError: error, mutate };
}

export async function logNutrition(data) {
  return fetcher("/api/client/nutrition", { method: "POST", body: JSON.stringify(data) });
}

// ========== Habits ==========
export function useMyHabits() {
  const { data, error, isLoading, mutate } = useSWR("/api/client/habits", fetcher);
  return { habits: data || [], isLoading, isError: error, mutate };
}

export function useDailyHabits(logDate) {
  const { data, error, isLoading, mutate } = useSWR(
    logDate ? `/api/client/habits/daily?log_date=${logDate}` : null, fetcher
  );
  return { habits: data || [], isLoading, isError: error, mutate };
}

export function useClientHabits(clientId) {
  const { data, error, isLoading, mutate } = useSWR(
    clientId ? `/api/admin/clients/${clientId}/habits` : null, fetcher
  );
  return { habits: data || [], isLoading, isError: error, mutate };
}

export function useClientDailyHabits(clientId, logDate) {
  const { data, error, isLoading, mutate } = useSWR(
    clientId && logDate ? `/api/admin/clients/${clientId}/habits/daily?log_date=${logDate}` : null, fetcher
  );
  return { habits: data || [], isLoading, isError: error, mutate };
}

export async function createHabit(data) {
  return fetcher("/api/client/habits", { method: "POST", body: JSON.stringify(data) });
}

export async function deleteHabit(id) {
  const token = localStorage.getItem("access_token");
  const resp = await fetch(`${API_URL}/api/client/habits/${id}`, {
    method: "DELETE", headers: { Authorization: `Bearer ${token}` },
  });
  if (!resp.ok) throw new Error("Erreur suppression habitude");
}

export async function toggleHabit(habitId, logDate, completed) {
  return fetcher("/api/client/habits/toggle", {
    method: "POST",
    body: JSON.stringify({ habit_id: habitId, log_date: logDate, completed }),
  });
}

// ========== Check-ins ==========
export function useMyCheckins() {
  const { data, error, isLoading, mutate } = useSWR("/api/client/checkins", fetcher);
  return { checkins: data || [], isLoading, isError: error, mutate };
}

export function useClientCheckins(clientId) {
  const { data, error, isLoading, mutate } = useSWR(
    clientId ? `/api/admin/clients/${clientId}/checkins` : null, fetcher
  );
  return { checkins: data || [], isLoading, isError: error, mutate };
}

export async function submitCheckin(data) {
  return fetcher("/api/client/checkins", { method: "POST", body: JSON.stringify(data) });
}
